{
  "Clear search": "Počisti iskanje"
}
